import { refreshCode2Factor } from "@/Services/TherapyApi/Auth";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";
import { hasValue } from "@/Utils/Objects";

async function regenerate2FCode(code: string): Promise<{ hash2F: string } | undefined> {
  const response = await refreshCode2Factor({ hash_2F: code }).catch(() => undefined);

  if (!hasValue(response) || isApiError(response)) {
    return undefined;
  }

  return {
    hash2F: response.hash_2F!,
  };
}

export default regenerate2FCode;
